"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPermissions = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _filters = require("../../constants/filters");

var _data = require("../../constants/data");

var _Utils = _interopRequireDefault(require("../../utils/Utils"));

var _TableView = require("../../components/DataView/TableView");

var _SwitchStatusBatch = require("./SwitchStatusBatch");

var _tableData = require("./tableData");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TabPane = _antd.Tabs.TabPane;

var UserPermissions =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserPermissions, _React$Component);

  function UserPermissions() {
    _classCallCheck(this, UserPermissions);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserPermissions).apply(this, arguments));
  }

  _createClass(UserPermissions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isAdmin = _this$props.isAdmin,
          translate = _this$props.translate,
          isPartnerEmulationMode = _this$props.isPartnerEmulationMode;
      return _react["default"].createElement(_antd.Tabs, {
        defaultActiveKey: "1"
      }, _react["default"].createElement(TabPane, {
        key: "1",
        tab: translate('tab/userPermissions')
      }, _react["default"].createElement(_SwitchStatusBatch.SwitchStatusBatch, null), _react["default"].createElement(_TableView.TableView, {
        filterType: _filters.FILTER_TYPE.USER_PERMISSIONS,
        dataType: _data.DATA_TYPE.USER_PERMISSIONS,
        dataSource: {
          url: _data.DATA_URLS.USER_PERMISSIONS_URL,
          mapping: function mapping(data) {
            return {
              records: data.items,
              total: data.total
            };
          }
        },
        columns: _Utils["default"].checkAdmin(_tableData.tableData.userPermissions.columns, isAdmin || isPartnerEmulationMode, 'partnerCompany'),
        tableSort: _tableData.tableData.tableSort,
        hideDownloadButtons: true
      })));
    }
  }]);

  return UserPermissions;
}(_react["default"].Component);

exports.UserPermissions = UserPermissions;